import React from 'react';
import { useSelector } from 'react-redux';
import Loading from 'components/World/Loading';

/**
 * Global loading overlay that renders at the App level.
 * This ensures it appears above ALL other components including
 * SpeechToTextService/LiveKitTextInput which are also at the App level.
 */
const GlobalLoadingOverlay = () => {
  const worldLoading = useSelector(state => state.world.worldLoading);

  return <Loading loading={worldLoading} />;
};

export default GlobalLoadingOverlay;
